import { getApiContext, getApiUrl } from './api';
import {
    Activity,
    CheckinResult,
    ContactData,
    ProfileData,
    ResetData,
    SiteData,
    StyleData,
    WorkerData,
} from '../model/Model';
import { CheckinForm } from './checkin-flow';

interface HttpResponse<T> extends Response {
    parsedBody?: T;
}

export async function http<T>(request: RequestInfo): Promise<HttpResponse<T>> {
    const response: HttpResponse<T> = await fetch(request);
    try {
        response.parsedBody = await response.json();
    } catch (ex) {
    }
    if (!response.ok) {
        throw new Error(response.status.toString());
    }
    return response;
}

export async function get<T>(
    path: string,
    args: RequestInit = {method: 'get'}
): Promise<HttpResponse<T>> {
    return await http<T>(new Request(path, args));
}

export async function post<T>(
    path: string,
    // eslint-disable-next-line
    body: any,
    args: RequestInit = {
        method: 'post',
        body: JSON.stringify(body),
        headers: new Headers({'Content-Type': 'application/json'})
    }
): Promise<HttpResponse<T>> {
    return await http<T>(new Request(path, args));
}

export async function del<T>(
    path: string,
    args: RequestInit = {method: 'delete'}
): Promise<HttpResponse<T>> {
    return await http<T>(new Request(path, args));
}

export async function put<T>(
    path: string,
    // eslint-disable-next-line
    body: any,
    args: RequestInit = {
        method: 'put',
        body: JSON.stringify(body),
        headers: new Headers({'Content-Type': 'application/json'})
    }
): Promise<HttpResponse<T>> {
    return await http<T>(new Request(path, args));
}

export const checkIn = async (token: string, form: CheckinForm) => {
    const url = `${getApiUrl()}${getApiContext()}/api/v1/checkin/${token}`;
    return await post<CheckinResult>(url, form).then(r => r.parsedBody);
}

export const checkOut = async (token: string, workerId: number) => {
    const url = `${getApiUrl()}${getApiContext()}/api/v1/checkout/${token}/${workerId}`;
    return await del<WorkerData>(url).then(r => r.parsedBody);
}

export const getWorker = async (token: string, workerId: number) => {
    const url = `${getApiUrl()}${getApiContext()}/api/v1/worker/${token}/${workerId}`;
    return await get<WorkerData>(url).then(r => r.parsedBody);
}

export const resolveStyle = async (token: string) => {
    const url = `${getApiUrl()}${getApiContext()}/api/v1/style/${token}`;
    return await get<StyleData>(url).then(r => r.parsedBody);
}

export const searchWorker = async (token: string, profileData: ProfileData) => {
    const url = `${getApiUrl()}${getApiContext()}/api/v1/worker/${token}`;
    return await post<WorkerData>(url, profileData).then(r => r.parsedBody);
}

export const searchWorkerById = async (token: string, workerId: number) => {
    const url = `${getApiUrl()}${getApiContext()}/api/v1/worker/${token}/${workerId}`;
    return await post<WorkerData>(url, {}).then(r => r.parsedBody);
}

export const resolveToken = async (token: string) => {
    const url = `${getApiUrl()}${getApiContext()}/api/v1/token/${token}`;
    return await get<SiteData>(url).then(r => r.parsedBody);
}

export const resetCache = async (token: string) => {
    const url = `${getApiUrl()}${getApiContext()}/api/v1/reset/${token}`;
    return await get<ResetData>(url).then(r => r.parsedBody);
}

export const getContacts = async (token: string) => {
    const url = `${getApiUrl()}${getApiContext()}/api/v1/contact/${token}`;
    return await get<ContactData[]>(url).then(r => r.parsedBody);
};

export const getActivities = async (token: string, typeId: number | undefined) => {
    let url = `${getApiUrl()}${getApiContext()}/api/v1/activity/${token}`;
    if (typeId) {
        url = `${url}?tid=${typeId}`
    }
    return await get<Activity[]>(url).then(r => r.parsedBody);
};
